export default __webpack_public_path__ + "915aa10600142f04d415b8b144f92324.svg";